import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const dest = sessionStorage.getItem("postGoogleRedirect") || "/app";
    sessionStorage.removeItem("postGoogleRedirect");
    if (!m) { navigate(dest, { replace: true }); return; }
    loginWithGoogle(decodeURIComponent(m[1]))
      .then(() => {
        window.history.replaceState(null, "", window.location.pathname);
        navigate(dest, { replace: true });
      })
      .catch(() => {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen grid place-items-center font-serif text-2xl text-stone-300" style={{ background: "#FDFBF7" }} data-testid="auth-callback">
      Signing you in…
    </div>
  );
}
